import React from "react";

export function TableSkeleton({ rows = 5, cols = 6 }) {
  return (
    <div className="skeleton-table">
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="skeleton-row" style={{ display: "flex", gap: 12, padding: "12px 0" }}>
          {Array.from({ length: cols }).map((_, c) => (
            <div
              key={c}
              className="skeleton-cell"
              style={{
                flex: 1,
                height: 20,
                background: "linear-gradient(90deg, #eee 25%, #f5f5f5 50%, #eee 75%)",
                backgroundSize: "200% 100%",
                animation: "shimmer 1.2s ease-in-out infinite",
                borderRadius: 4,
              }}
            />
          ))}
        </div>
      ))}
    </div>
  );
}

export function CardSkeleton() {
  return (
    <div className="skeleton-card" style={{ padding: 24, background: "#fff", borderRadius: 8, marginBottom: 16 }}>
      <div
        style={{ width: "60%", height: 24, background: "#eee", borderRadius: 4, marginBottom: 16, animation: "shimmer 1.2s ease-in-out infinite", backgroundSize: "200% 100%" }}
      />
      <div
        style={{ width: "40%", height: 16, background: "#eee", borderRadius: 4, marginBottom: 8, animation: "shimmer 1.2s ease-in-out infinite", backgroundSize: "200% 100%" }}
      />
      <div
        style={{ width: "80%", height: 16, background: "#eee", borderRadius: 4, animation: "shimmer 1.2s ease-in-out infinite", backgroundSize: "200% 100%" }}
      />
    </div>
  );
}
